import React from "react";
import { Stack } from "@mui/material";
import BookingTypeSelector from "../../../components/Reports/CapacityFilter/DateAndTypeSelector/booking-type-selector.partial";
import type { ScheduleToolbarProps } from "../../Schedule/partial/ScheduleToolbar.partial";
import { ScheduleColleagueSelect } from "../../Schedule/partial/ScheduleColleagueSelect.partial";
import { ScheduleModeToggle } from "../../Schedule/partial/ScheduleModeToggle.partial";
import {
  ScheduleResourceAutocomplete,
  type ScheduleResourceAutocompleteOption
} from "../../Schedule/partial/ScheduleResourceAutocomplete.partial";
import { dashboard2ScheduleFilterPanelSx } from "../dashboard2-status.styles";

export type Dashboard2ScheduleFilterPanelProps = Omit<
  ScheduleToolbarProps,
  "viewToggleSlot" | "multiDeleteSlot" | "scheduleViewMode" | "onScheduleViewModeChange"
>;

export const Dashboard2ScheduleFilterPanel: React.FC<Dashboard2ScheduleFilterPanelProps> = ({
  scheduleMode,
  onScheduleModeChange,
  isColleagueMode,
  isResourceMode,
  containerRef,
  tagLimit,
  colleagues,
  selectedColleagues,
  scheduleColleaguesIsFetching,
  storedScheduleColleaguesIsFetching,
  preStoredColleagues,
  isFirstAidSelected,
  onSelectedColleaguesChange,
  onStoreSelectedColleagues,
  resourceAvailableTypes,
  resourceBookingType,
  onResourceBookingTypeChange,
  onResourceFetchEnable,
  resourceAutocompleteLoading,
  bookableBookingObjectsError,
  resourceAutocompleteOptions,
  selectedResource,
  onSelectedResourceChange
}) => {
  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      alignItems="center"
      useFlexGap
      spacing={2}
      sx={dashboard2ScheduleFilterPanelSx}
      data-testid="dashboard2-schedule-filter-panel"
    >
      <ScheduleModeToggle
        scheduleMode={scheduleMode}
        setScheduleMode={onScheduleModeChange}
        compact
      />

      {isColleagueMode && colleagues.length >= 1 && (
        <ScheduleColleagueSelect
          containerRef={containerRef}
          tagLimit={tagLimit}
          colleagues={colleagues}
          selectedColleagues={selectedColleagues}
          scheduleColleaguesIsFetching={scheduleColleaguesIsFetching}
          storedScheduleColleaguesIsFetching={storedScheduleColleaguesIsFetching}
          preStoredColleagues={preStoredColleagues}
          isFirstAidSelected={isFirstAidSelected}
          setSelectedColleagues={onSelectedColleaguesChange}
          handleStoredScheduleColleagues={onStoreSelectedColleagues}
        />
      )}

      {isResourceMode && (
        <>
          {resourceAvailableTypes.length > 0 && (
            <BookingTypeSelector
              buttonStyle={{ fontSize: 24 }}
              iconSize="20px"
              typToggle={resourceBookingType}
              setTypToggle={nextType => {
                onResourceBookingTypeChange(nextType);
              }}
              onEnableFetch={() => {
                onResourceFetchEnable?.();
              }}
              allowedBookingTypes={resourceAvailableTypes}
            />
          )}
          <ScheduleResourceAutocomplete
            isLoading={resourceAutocompleteLoading}
            loadError={bookableBookingObjectsError}
            options={resourceAutocompleteOptions}
            value={selectedResource}
            onResourceChange={(value: ScheduleResourceAutocompleteOption | null) => {
              onSelectedResourceChange(value);
            }}
          />
        </>
      )}
    </Stack>
  );
};
